<template>
  <div class="family-breadcrumbs-wrapper">
    <span class="breadcrumb-first-level text-body-2">
      {{ groupLabel }}
    </span>
    <span class="breadcrumb-separator text-body-2">/</span>
    <v-menu
      v-model="menuOpen"
      class="breadcrumb-dropdown-container"
      content-class="breadcrumb-dropdown-content"
      close-on-content-click
    >
      <template #activator="{ props: activatorProps }">
        <DpplChip
          v-bind="activatorProps"
          class="breadcrumb-dropdown-activator"
          arrow
          :chip-height="36"
          chip-color="white"
          :is-pill="false"
          :is-active="menuOpen"
        >
          <template #label>
            {{ familyLabel }}
          </template>
        </DpplChip>
      </template>
      <v-card
        min-width="220"
        max-height="320"
        class="family-dropdown-card"
      >
        <v-list class="py-0 family-dropdown-list">
          <v-list-item
            v-for="family in familiesInGroup"
            :key="family.ulid || family.name || 'uncategorized'"
            class="family-dropdown-item text-body-2"
            @click="onSelectFamily(family)"
          >
            <v-list-item-title>
              {{ family.name || 'Uncategorized' }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import DpplChip from '@/components/datapeople/DpplChip.vue';
import { useJobArchitecture } from '@/stores/jobArchitecture/jobArchitecture';

const router = useRouter();
const { treeData, selectedFamily } = storeToRefs(useJobArchitecture());

const menuOpen = ref(false);

const selectedGroup = computed(() => {
  const family = selectedFamily.value;
  const groups = treeData.value?.groups;

  if (!family || !Array.isArray(groups)) return null;

  return groups.find((group) => group.families?.some(
    (groupFamily) => groupFamily.ulid === family.ulid,
  ));
});

const familiesInGroup = computed(() => selectedGroup.value?.families || []);

const groupLabel = computed(() => selectedGroup.value?.name || 'Uncategorized');

const familyLabel = computed(() => selectedFamily.value?.name || 'Uncategorized');

const onSelectFamily = (family) => {
  menuOpen.value = false;

  router.push({
    name: 'job-architecture-family',
    params: { familyUlid: family.ulid },
  });
};
</script>

<style scoped lang="less">
.family-breadcrumbs-wrapper {
  display: flex;
  align-items: center;
}

.breadcrumb-first-level {
  color: @text-dark;
}

.breadcrumb-separator {
  color: @grey-500;
  margin: 0 8px;
}

.breadcrumb-dropdown-activator {
  border: 1px solid @stroke-default;
  border-radius: 8px;

  :deep(.v-chip__overlay) {
    display: none;
  }
}

.breadcrumb-dropdown-activator:hover {
  background: @bg-brand-default !important;
  color: @white !important;
}

:deep(.v-chip.v-chip--size-default) {
  font-size: 13px;
}
</style>
